/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useNotification } from '@centecomm/portal-service-react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { globalMessageActionCreators, Notifications } from 'State';
import { useTranslation } from 'react-i18next';
import { SpinningLoader } from '../../Icons/Animated';
import { Button } from '../../Shared/Button';
import { ConfirmationModal } from '../../Shared/ConfirmationModal';
import { FlexWrapper } from '../../Shared/FlexWrapper';

interface ClearAllNotificationsButtonProps {
    clearAllCallback: () => void;
}

function ClearAllNotificationsButton({
    clearAllCallback,
}: ClearAllNotificationsButtonProps): React.ReactElement<ClearAllNotificationsButtonProps> {
    const dispatch = useDispatch();

    const [deleting, setDeleting] = useState<boolean>(false);
    const [showModal, toggleShowModal] = useState<boolean>(false);

    const { deleteAllNotifications } = useNotification();

    const { t } = useTranslation('notificationsFeature');

    const deleteAll = () => {
        setDeleting(true);

        deleteAllNotifications()
            .then(() => {
                dispatch(
                    globalMessageActionCreators.addSuccessMessage(t('notificationsFeature:clearNotifications.clearSuccess')),
                );

                dispatch({
                    type: Notifications.Actions.SET_COUNT,
                    payload: 0,
                } as Notifications.ActionTypes);

                clearAllCallback();
            })
            .catch(() => {
                dispatch(
                    globalMessageActionCreators.addSuccessMessage(t('notificationsFeature:clearNotifications.clearError')),
                );
            })
            .finally(() => {
                setDeleting(false);
                toggleShowModal(false);
            });
    };

    return (
        <>
            <Button
                warning
                lowProfile
                text={t('notificationsFeature:clearNotifications.clearAll')}
                callback={() => toggleShowModal(true)}
                disable={deleting}
            />
            {showModal && (
                <ConfirmationModal
                    header={t('notificationsFeature:clearNotifications.clearAllHeader')}
                    onCancel={() => toggleShowModal(false)}
                    onConfirm={deleteAll}
                    disableButton={deleting}
                >
                    {deleting ? (
                        <FlexWrapper align="center" justify="center">
                            <SpinningLoader aspect="2.5rem" />
                        </FlexWrapper>
                    ) : (
                        <>
                            <p>{t('notificationsFeature:clearNotifications.clearAllDescription')}</p>
                            <p>
                                <strong>{t('notificationsFeature:clearNotifications.proceedQuestion')}</strong>
                            </p>
                        </>
                    )}
                </ConfirmationModal>
            )}
        </>
    );
}

export default ClearAllNotificationsButton;
